import React, { useState, useRef } from 'react';

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Input,
  Container,
  Row,
  Col,
  InputGroupAddon,
  InputGroup,
  InputGroupText,
} from 'reactstrap';
// core components
import Avatar from 'react-avatar';
import { Formik, Form } from 'formik';
import { toast } from 'react-toastify';
import { useMutation, useQueryClient } from 'react-query';
import Spin from 'antd/lib/spin';
import 'antd/lib/spin/style/index.css';
import AntButton from 'antd/lib/button';
import { LoadingOutlined } from '@ant-design/icons';
import 'antd/lib/button/style/index.css';
// import VerifyOTP Modal from '../../components/Modals/VerifyOTPModal';
import { compressImage } from '../../utils/misc';
import backendAxios from '../../utils/axios';
import axios from 'axios';

//Queries
import { updateUserInfo } from '../../utils/queries/profileQueries';

//Utilities
import { get, isEmpty } from 'lodash-es';
import { createUseStyles } from 'react-jss';
import VerifyOTPEmbedded from 'components/Common/VerifyOTPEmbedded';

const useStyles = createUseStyles({
  phoneEmailUpdateButton: {
    marginTop: '4px',
    height: '43px',
    backgroundColor: '#2675b8',
    width: '100%',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#2675b8!important',
      color: 'white!important',
    },
    '&:focus': {
      backgroundColor: '#2675b8!important',
      color: 'white!important',
    },
    borderRadius: '5px',
  },
  antSpinner: {
    color: 'black',
    '& .ant-spin-dot-item': {
      backgroundColor: '#2675b8',
    },
  },
  updateProfileButton: {
    marginTop: '4px',
    height: '43px',
    backgroundColor: '#2675b8',
    marginLeft: '65px',
    width: '100%',
    color: 'white',
    border: 'none',
    fontWeight: 'normal',
    '&:hover': {
      backgroundColor: '#2675b8!important',
      color: 'white!important',
    },
    '&:focus': {
      backgroundColor: '#2675b8!important',
      color: 'white!important',
    },
    borderRadius: '5px',
  },
});

const Profile = ({ accountInfo }) => {
  const classes = useStyles();
  const queryQlient = useQueryClient();

  const { mutateAsync: updateAccountInfo } = useMutation(updateUserInfo);
  //Setting external update state for updating userInfo
  const [phoneNumber, setPhoneNumber] = useState(
    get(accountInfo, 'user.PHONE_NUMBER'),
  );
  const [email, setEmail] = useState(get(accountInfo, 'user.EMAIL'));
  const [updatingUserInfo, setUpdatingUserInfo] = useState(false);
  const [updatingPhoneNumber, setUpdatingPhoneNumber] = useState(false);
  const [updatingEmail, setUpdatingEmail] = useState(false);

  /* ***** Verify OTP Modal States ***** */
  const [verifyOTPModalOpen, setVerifyOTPModalOpen] = useState(false);
  const toggleVerifyOTPModal = () => setVerifyOTPModalOpen(!verifyOTPModalOpen);
  const [verificationAttribute, setVerificationAttribute] =
    useState('phone_number');
  const [verificationAttributeValue, setVerificationAttributeValue] =
    useState('');
  /* ************************************ */

  async function updateUserInformation(values, setUpdating) {
    try {
      if (isEmpty(values.firstName) || isEmpty(values.lastName)) {
        return toast.dark('First Name or Last Name cannot be empty', {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      setUpdatingUserInfo(true);
      setUpdating(true);
      const formattedValues = {
        'custom:firstName': get(values, 'firstName'),
        'custom:lastName': get(values, 'lastName'),
        'custom:street': get(values, 'address'),
        'custom:zipcode': get(values, 'zipcode'),
        'custom:city': get(values, 'city'),
        'custom:state': get(values, 'state'),
      };

      await updateAccountInfo(formattedValues);
      await queryQlient.fetchQuery('customer/whoAmI');
      toast.dark('Profile updated.', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } catch (error) {
      toast.dark(error.message, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setUpdating(false);
    setUpdatingUserInfo(false);
  }

  async function updatePhoneNumber() {
    try {
      if (!phoneNumber || isEmpty(phoneNumber)) {
        return toast.dark('Phone Number is empty', {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      setUpdatingPhoneNumber(true);

      const formattedValue = {
        phone_number: phoneNumber,
      };

      await updateAccountInfo(formattedValue);
      await queryQlient.fetchQuery('customer/whoAmI');

      //Start Verification
      setVerificationAttribute('phone_number');
      setVerificationAttributeValue(phoneNumber);
      toggleVerifyOTPModal();
      setUpdatingPhoneNumber(false);
    } catch (error) {
      toast.dark(error.message, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setUpdatingPhoneNumber(false);
  }

  async function updateEmail() {
    try {
      if (!email || isEmpty(email)) {
        return toast.dark('Email is empty', {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      setUpdatingEmail(true);

      const formattedValue = {
        email,
      };

      await updateAccountInfo(formattedValue);
      await queryQlient.fetchQuery('customer/whoAmI');

      //Start Verification
      setVerificationAttribute('email');
      setVerificationAttributeValue(email);
      toggleVerifyOTPModal();
      setUpdatingEmail(false);
    } catch (error) {
      toast.dark(error.message, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setUpdatingEmail(false);
  }

  /* Image profile picture */
  const imageRef = useRef();
  const [isImageUploading, setIsImageUploading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [uploadStatus, setUploadStatus] = useState(0);
  const [showProfilePicture, setShowProfilePicture] = useState(true);

  async function startUpload(file, url) {
    try {
      const imageUploadAxios = axios.create();
      await imageUploadAxios.put(url, file, {
        headers: {
          'Content-Type': file.type,
        },
        // handle upload progress
        onUploadProgress: (progressEvent) => {
          const uploadPercent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          setUploadStatus(uploadPercent);
        },
      });
      // File upload success
      //const imgUrl = url.split('?')[0];
      await queryQlient.fetchQuery('customer/whoAmI');

      setUploadStatus(0);
    } catch (error) {
      return toast.dark(error.message, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  async function saveImage(file) {
    try {
      setUploadStatus(0);
      const imageUrlData = await backendAxios
        .post(`/users/profilePicSignedLink`, {
          params: {
            fileType: file.type,
          },
        })
        .then((res) => res.data);
      await startUpload(file, get(imageUrlData, 'UPLOAD_SIGNED_URL.url'));
    } catch (error) {
      return toast.dark(error.message, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  async function handleImageUpload(e) {
    setIsImageUploading(true);
    let file = null;
    if (e.target.files instanceof FileList) {
      [file] = e.target.files;
    } else if (e.dataTransfer.files instanceof FileList) {
      [file] = e.dataTransfer.files;
    }
    if (!file) {
      return undefined;
    }
    if (file.type.split('/')[0].toLowerCase() !== 'image') {
      setIsImageUploading(false);
      return toast.dark(`Please select only images`, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    try {
      file = await compressImage(file, (percent) => {
        setUploadStatus(percent);
      });
      await saveImage(file);
      await queryQlient.fetchQuery('customer/whoAmI');
      setIsImageUploading(false);
    } catch (error) {
      setIsImageUploading(false);
      return toast.dark(error.message, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setIsImageUploading(false);
    return undefined;
  }

  const getTestForButton = (isVerified) => {
    return isVerified === 'true' || isVerified === true ? 'Update' : 'Validate';
  };

  /* ********************* */

  return (
    <>
      <Container className="mt-7" fluid>
        <Row
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '80vh',
          }}
        >
          <Col className="order-xl-1" xl="7">
            <Spin
              spinning={updatingUserInfo}
              size="large"
              className={classes.antSpinner}
              tip="Updating Account details..."
              indicator={<LoadingOutlined style={{ color: '#2675b8' }} />}
            >
              <Card className="bg-secondary ">
                <CardBody>
                  <div className="pl-lg-4 pr-lg-4 pt-lg-3">
                    <Row>
                      <Col
                        lg="12"
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                        }}
                      >
                        <FormGroup
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexDirection: 'column',
                          }}
                        >
                          <input
                            ref={imageRef}
                            type="file"
                            accept="image/*"
                            style={{ display: 'none' }}
                            onChange={handleImageUpload}
                          />
                          <div
                            onDragOver={(e) => e.preventDefault()}
                            onDrop={(e) => {
                              e.preventDefault();
                              handleImageUpload(e);
                            }}
                            onClick={() => imageRef.current.click()}
                          >
                            {get(accountInfo, 'user.IMAGE') &&
                            showProfilePicture ? (
                              <Spin
                                spinning={isImageUploading}
                                size="large"
                                className={classes.antSpinner}
                                tip="Uploading Image"
                                indicator={
                                  <LoadingOutlined
                                    style={{ color: '#2675b8' }}
                                  />
                                }
                              >
                                <img
                                  src={get(accountInfo, 'user.IMAGE')}
                                  onError={() => setShowProfilePicture(false)}
                                  alt=""
                                  style={{
                                    objectFit: 'fill',
                                    maxWidth: '100%',
                                    width: '150px',
                                    height: '150px',
                                    borderRadius: '50%',
                                  }}
                                />
                              </Spin>
                            ) : isEmpty(
                                get(accountInfo, 'user.NAME')?.trim(),
                              ) ? (
                              <Avatar
                                size={150}
                                color="rgb(38,117,184, 0.2)"
                                fgColor="#2675b8"
                                round
                                src="https://www.gravatar.com/avatar/00000000000000000000000000000000?d=retro"
                              />
                            ) : (
                              <Avatar
                                name={get(accountInfo, 'user.NAME')}
                                size={150}
                                color="rgb(38,117,184, 0.2)"
                                fgColor="#2675b8"
                                round
                              />
                            )}
                          </div>

                          <label
                            className="form-control-label"
                            htmlFor="input-first-name"
                            style={{
                              marginTop: '15px',
                              fontWeight: 'normal',
                            }}
                          >
                            {isEmpty(get(accountInfo, 'user.FIRSTNAME', '')) ||
                            isEmpty(get(accountInfo, 'user.LASTNAME', ''))
                              ? get(accountInfo, 'user.PHONE_NUMBER', '')
                              : get(accountInfo, 'user.NAME', '')}
                          </label>
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <Formik
                    initialValues={{
                      firstName: get(accountInfo, 'user.FIRSTNAME', ''),
                      lastName: get(accountInfo, 'user.LASTNAME', '')?.trim(),
                      address: get(accountInfo, 'user.STREET', '')?.trim(),
                      city: get(accountInfo, 'user.CITY', '')?.trim(),
                      state: get(accountInfo, 'user.STATE', '')?.trim(),
                      zipcode: get(accountInfo, 'user.ZIPCODE', '')?.trim(),
                    }}
                    onSubmit={(values, { resetForm, setSubmitting }) => {
                      updateUserInformation(values, setSubmitting);
                    }}
                  >
                    {({ values, isSubmitting, setFieldValue }) => (
                      <Form>
                        <div className="pl-lg-4 pr-lg-4 ">
                          <Row style={{ alignItems: 'center' }}>
                            <Col lg="2">
                              <label
                                className="form-control-label"
                                htmlFor="input-first-name"
                              >
                                First name
                              </label>
                            </Col>
                            <Col lg="10">
                              <FormGroup style={{ marginBottom: '0px' }}>
                                <Input
                                  value={get(values, 'firstName')}
                                  name="firstName"
                                  onChange={(e) =>
                                    setFieldValue('firstName', e.target.value)
                                  }
                                  type="text"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row
                            style={{ alignItems: 'center', marginTop: '15px' }}
                          >
                            <Col lg="2">
                              <label
                                className="form-control-label"
                                htmlFor="input-first-name"
                              >
                                Last name
                              </label>
                            </Col>
                            <Col lg="10">
                              <FormGroup style={{ marginBottom: '0px' }}>
                                <Input
                                  value={get(values, 'lastName')}
                                  name="lastName"
                                  onChange={(e) =>
                                    setFieldValue('lastName', e.target.value)
                                  }
                                  type="text"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row
                            style={{ alignItems: 'center', marginTop: '15px' }}
                          >
                            <Col lg="2">
                              <label
                                className="form-control-label"
                                htmlFor="input-first-name"
                              >
                                Address
                              </label>
                            </Col>
                            <Col lg="10">
                              <FormGroup style={{ marginBottom: '0px' }}>
                                <Input
                                  value={get(values, 'address')}
                                  name="address"
                                  onChange={(e) =>
                                    setFieldValue('address', e.target.value)
                                  }
                                  type="textarea"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row
                            style={{ alignItems: 'center', marginTop: '15px' }}
                          >
                            <Col lg="2">
                              <label
                                className="form-control-label"
                                htmlFor="input-first-name"
                              >
                                City
                              </label>
                            </Col>
                            <Col lg="10">
                              <FormGroup style={{ marginBottom: '0px' }}>
                                <Input
                                  value={get(values, 'city')}
                                  name="city"
                                  onChange={(e) =>
                                    setFieldValue('city', e.target.value)
                                  }
                                  type="text"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row
                            style={{ alignItems: 'center', marginTop: '15px' }}
                          >
                            <Col lg="2">
                              <label
                                className="form-control-label"
                                htmlFor="input-first-name"
                              >
                                State
                              </label>
                            </Col>
                            <Col lg="10">
                              <FormGroup style={{ marginBottom: '0px' }}>
                                <Input
                                  value={get(values, 'state')}
                                  name="state"
                                  onChange={(e) =>
                                    setFieldValue('state', e.target.value)
                                  }
                                  type="text"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row
                            style={{ alignItems: 'center', marginTop: '15px' }}
                          >
                            <Col lg="2">
                              <label
                                className="form-control-label"
                                htmlFor="input-first-name"
                              >
                                Zip code
                              </label>
                            </Col>
                            <Col lg="10">
                              <FormGroup style={{ marginBottom: '0px' }}>
                                <Input
                                  value={get(values, 'zipcode')}
                                  name="zipcode"
                                  onChange={(e) =>
                                    setFieldValue('zipcode', e.target.value)
                                  }
                                  type="number"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row
                            style={{
                              alignItems: 'center',
                              marginTop: '15px',
                              justifyContent: 'center',
                            }}
                          >
                            <Col lg="4">
                              <Button
                                type="submit"
                                className={classes.updateProfileButton}
                              >
                                Update
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      </Form>
                    )}
                  </Formik>

                  <hr className="my-4" />
                  {verifyOTPModalOpen && (
                    <VerifyOTPEmbedded
                      toggleVerifyOTPModalOpen={toggleVerifyOTPModal}
                      verifyOTPModalOpen={verifyOTPModalOpen}
                      verificationAttribute={verificationAttribute}
                      verificationAttributeValue={verificationAttributeValue}
                    />
                  )}

                  <div className="pl-lg-4 pr-lg-4">
                    <Row>
                      <Col lg="9">
                        <FormGroup>
                          <label className="form-control-label">
                            Phone Number
                          </label>
                          <InputGroup>
                            <Input
                              value={phoneNumber}
                              onChange={(e) => setPhoneNumber(e.target.value)}
                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText>
                                {get(
                                  accountInfo,
                                  'user.PHONE_NUMBER_VERIFIED',
                                ) === 'true' ||
                                get(
                                  accountInfo,
                                  'user.PHONE_NUMBER_VERIFIED',
                                ) === true ? (
                                  <i
                                    className="fas fa-check-circle"
                                    style={{
                                      color: '#28a745',
                                      fontSize: '19px',
                                    }}
                                  />
                                ) : (
                                  <i
                                    className="fas fa-exclamation-circle"
                                    style={{
                                      color: '#f74343',
                                      fontSize: '19px',
                                    }}
                                  />
                                )}
                              </InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col
                        lg="3"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <AntButton
                          className={classes.phoneEmailUpdateButton}
                          loading={updatingPhoneNumber}
                          onClick={updatePhoneNumber}
                        >
                          {updatingPhoneNumber
                            ? 'Updating'
                            : getTestForButton(
                                get(accountInfo, 'user.PHONE_NUMBER_VERIFIED'),
                              )}
                        </AntButton>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg="9">
                        <FormGroup>
                          <label className="form-control-label">Email</label>
                          <InputGroup>
                            <Input
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText>
                                {get(accountInfo, 'user.EMAIL_VERIFIED') ===
                                  'true' ||
                                get(accountInfo, 'user.EMAIL_VERIFIED') ===
                                  true ? (
                                  <i
                                    className="fas fa-check-circle"
                                    style={{
                                      color: '#28a745',
                                      fontSize: '19px',
                                    }}
                                  />
                                ) : (
                                  <i
                                    className="fas fa-exclamation-circle"
                                    style={{
                                      color: '#f74343',
                                      fontSize: '19px',
                                    }}
                                  />
                                )}
                              </InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </FormGroup>
                      </Col>
                      <Col
                        lg="3"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <AntButton
                          className={classes.phoneEmailUpdateButton}
                          loading={updatingEmail}
                          onClick={updateEmail}
                        >
                          {updatingEmail
                            ? 'Updating'
                            : getTestForButton(
                                get(accountInfo, 'user.EMAIL_VERIFIED'),
                              )}
                        </AntButton>
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Spin>
          </Col>

          {/* <VerifyOTPModal
            toggleVerifyOTPModalOpen={toggleVerifyOTPModal}
            verifyOTPModalOpen={verifyOTPModalOpen}
            verificationAttribute={verificationAttribute}
            verificationAttributeValue={verificationAttributeValue}
          /> */}
        </Row>
      </Container>
    </>
  );
};

export default Profile;
